<template>
  <div
    class="topbar w-full lg:h-12 flex justify-center items-center bg-yellow-600 overflow-hidden relative py-2 px-4 lg:py-0"
    v-if="isPendingPayment"
  >
    <Icon
      name="Exclamation"
      class="w-24 h-24 text-yellow-700 transform rotate-45 absolute"
    />
    <div
      class="w-10 h-10 rounded-lg bg-yellow-700 mr-3 grid place-content-center relative z-10"
    >
      <Icon name="Exclamation" class="w-8 h-8 text-white" />
    </div>
    <p class="text-white text-base relative z-10 leading-tight">
      We are checking your payment, If you don't get your upgrade the next hour,
      contact support.
    </p>
    <Icon
      name="Exclamation"
      class="w-32 h-32 text-yellow-700 transform -rotate-45 absolute right-0"
    />
    <Icon
      name="Close"
      class="w-8 h-8 text-white hover:opacity-75 absolute right-0 mr-4 cursor-pointer"
      @click="hiddenTopbar"
    />
  </div>
</template>

<script>
import Icon from "@/components/UI/Icon";
import { computed, ref, watch } from "vue";
import { useStore } from 'vuex';
import Cookies from "js-cookie";

export default {
  components: { Icon },
  setup() {
    const store = useStore();

    const isPendingPayment = ref(false);

    const role = computed(() => store.state.role)
    const user = computed(() => store.state.user)

    watch(user, () => {
      handleTopbar()
    })

    const handleTopbar = () => {
      const pui = Cookies.get(`pending_upgrade_${user.value.id}`)
      if (["free"].includes(role.value) && pui) {
        isPendingPayment.value = true;
      }
    }

    const hiddenTopbar = () => {
      isPendingPayment.value = false;
    };

    return { hiddenTopbar, isPendingPayment, role, handleTopbar };
  },
};
</script>

<style scoped>
.topbar {
  box-shadow: inset 0 -1px 10px 0 rgba(0, 0, 0, 0.2);
}
.topbar > svg {
  z-index: 1;
}
.topbar > svg:first-child {
  left: 15vw;
}
.icon_ban {
  right: 20vw;
}

.topbar > div > svg {
  animation-name: exclamation;
  animation-duration: 0.6s;
  animation-iteration-count: infinite;
  animation-direction: alternate;
}
@keyframes exclamation {
  from {
    @apply w-6 h-6;
  }
  to {
    @apply w-8 h-8;
  }
}
</style>
